import { actionTypes } from '../actions/types';

type AppActions = import('../actions/types').AppActions;

export interface KycReducer {
    kycBlocked: boolean;
    kycAnswered: boolean;
    kycBlockedToggle: boolean;
    kycSkipped: boolean;
}

export const initialState: KycReducer = {
    kycBlocked: false,
    kycAnswered: false,
    kycBlockedToggle: false,
    kycSkipped: false,
};

export const kycReducer = (state = initialState, action: AppActions = {} as AppActions): KycReducer => {
    switch (action.type) {
        case actionTypes.FETCH_CUSTOMER_KYC_FULFILLED: {
            const { kycBlocked } = action.payload;
            return {
                ...state,
                kycBlocked,
            };
        }

        case actionTypes.SET_KYC_ANSWERED: {
            return {
                ...state,
                kycAnswered: true,
            };
        }

        case actionTypes.KYC_BLOCKED_TOGGLE: {
            return {
                ...state,
                kycBlockedToggle: action.payload,
            };
        }

        case actionTypes.KYC_SKIP: {
            return {
                ...state,
                kycSkipped: true,
                kycAnswered: true,
            };
        }

        default:
            return state;
    }
};
